<template>
  <div
    :class="$style.paywallContainer"
  >
    <div
      :class="$style.paywallMessage"
    >
      <h3 :class="$style.paywallHeading">
        {{ icon }} Looks like you’re growing. Congratulations!
      </h3>
      <p>
        {{ userLimitMessage || maxUsersMessageDefault }}
      </p>
    </div>
    <FlatActionButton
      :action="goToPricing"
      buttonClass="btnDefault"
    >
      Upgrade Now
    </FlatActionButton>
  </div>
</template>

<script>
import {
  BodyComponentConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapState } from 'vuex';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const { emojiUnicode } = BodyComponentConsts;

export default {
  name: 'ImportUsersPaywallMessage',

  components: {
    FlatActionButton,
  },

  props: {
    userLimitMessage: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      icon: emojiUnicode.partyPopper,
    };
  },

  computed: {
    ...mapState(settingsModule, [
      'maxSystemUsers',
    ]),

    maxUsersMessageDefault() {
      return `To upload more users and grow your account beyond ${this.maxSystemUsers} users, select one of our plans.`;
    },
  },

  methods: {
    goToPricing() {
      ModalEventBus.close();
      Util.redirect('#/pricing');
    },
  },
};
</script>

<style module>
@value (jcTertiary) from '~css/brand-colors.css';

.paywallContainer {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 24px;
  padding: 24px;
  position: relative;
}

.paywallContainer::before {
  background-color: jcTertiary;
  border-radius: 16px;
  content: '';
  display: block;
  height: 100%;
  left: 0;
  opacity: 0.08;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

.paywallMessage {
  text-align: center;
}

.paywallMessage > .paywallHeading {
  font-size: 2rem;
  font-weight: 700;
  line-height: 0.7;
  margin-top: 0;
}

</style>
